import { useState } from 'react'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'

import Home from '../home/Home'
import Friend from '../friend/Friend'
import Video from '../video/Video'
import Gallery from '../gallery/Gallery'
import Online from '../../components/online/Online'
import Modal from '../modal/Modal'

import './content.css'
import UserAppContext from '../../hook/UserAppContext'

const Content = () => { 

      const [home, setHome] = useState(true)
      const [friend, setFriend] = useState(false)
      const [video, setVideo] = useState(false)
      const [gallery, setGallery] = useState(false)
      const [modal, setModal] = useState(false)
      const [obj, setObj] = useState([])
      const [current, setCurrent] = useState('home')
      const {user, data} = UserAppContext()

      if(user.length === 0) return 

      const {friends, videos, galleries, banners} = user.user 
      const banner_title = banners.data ? data.banner.title : banners[0].title

      const setPage = (page) => {

            switch(page){

                  case 'home':
                        setHome(true)
                        setFriend(false)
                        setVideo(false)
                        setGallery(false)
                        setCurrent('home')
                  break
                  case 'friend':
                        setHome(false)
                        setFriend(true)
                        setVideo(false)
                        setGallery(false)
                        setCurrent('friend')
                  break
                  case 'video':
                        setHome(false)
                        setFriend(false)
                        setVideo(true)
                        setGallery(false)
                        setCurrent('video')
                  break
                  case 'gallery':
                        setHome(false)
                        setFriend(false)
                        setVideo(false)
                        setGallery(true)
                        setCurrent('gallery')
                  break
                  default:
                        setHome(true)
                        setFriend(false)
                        setVideo(false)
                        setGallery(false)
                  break
            }
      }

      const arrowPageLeft = () => {

            if(home) return 
            if(current === 'friend'){
                  setPage('home')
                  return
            }

            if(current === 'video'){
                  setPage('friend')
                  return
            }

            if(current === 'gallery'){
                  setPage('video')
                  return
            }
      }

      const arrowPageRight = () => {

            if(gallery) return 
            if(current === 'home'){
                  setPage('friend')
                  return
            }

            if(current === 'friend'){
                  setPage('video')
                  return
            }

            if(current === 'video'){
                  setPage('gallery')
                  return
            }
      }

      return (
            <div className="content">
                  <div className="header_content">
                        <div className="header_content__menu">
                              <ul className="menu_top">
                                    <li className={home ? "menu_top__item active" : "menu_top__item"} onClick={() => setPage('home')}><span className="menu_top__btn">Home</span></li>
                                    <li className={friend ? "menu_top__item active" : "menu_top__item"} onClick={() => setPage('friend')}><span className="menu_top__btn">Friends</span></li>
                                    <li className={video ? "menu_top__item active" : "menu_top__item"} onClick={() => setPage('video')}><span className="menu_top__btn">Video</span></li>
                                    <li className={gallery ? "menu_top__item active" : "menu_top__item"} onClick={() => setPage('gallery')}><span className="menu_top__btn">Gallery</span></li>
                              </ul>
                        </div>
                        <div className="header_content_status">
                              <div className="status_nav__arrow">
                                    <button className="btn_arrow" onClick={() => arrowPageLeft()}><BsArrowLeft/></button>
                                    <button className="btn_arrow" onClick={() => arrowPageRight()}><BsArrowRight/></button>
                              </div>
                              <div className="header_status_title">
                                    <h2 className="bg_grad">{banner_title}</h2>
                              </div>
                              <div className="header_status__online">
                                    <Online />
                              </div>
                        </div>
                  </div>
                  <div className="pages">
                        <Home isHome={home} />
                        <Friend data={friends} isFriend={friend} />
                        <Video data={videos} isVideo={video}/>
                        <Gallery data={galleries} isGallery={gallery} isSetModal={setModal} isSetObj={setObj}/>
                  </div>
                  <div className="footer_content">
                        <p>Theme - xatme.com - JasonOficial - 1202</p>
                  </div>
                  <Modal isModal={modal} isSetModal={setModal} isObj={obj}/>
            </div>
      )
}

export default Content
